import React, { useState } from 'react';
import './App.css';

function App() {
  const [currentImage, setCurrentImage] = useState(0);
  
  const galleryImages = [
    {
      src: "https://images.pexels.com/photos/8477297/pexels-photo-8477297.jpeg",
      alt: "Chef preparing food at culinary event"
    },
    {
      src: "https://images.unsplash.com/photo-1562158761-6f88c6940a24",  
      alt: "Professional cooking demonstration"
    },
    {
      src: "https://images.unsplash.com/photo-1656925549469-cb1bf8466e89",
      alt: "Chef preparing food in outdoor oven"
    },
    {
      src: "https://images.pexels.com/photos/14621560/pexels-photo-14621560.jpeg",
      alt: "Chef competition with dramatic flames"
    }
  ];

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="logo">
            <h1>Qatar Culinary Professionals</h1>
            <p>Excellence in Culinary Arts</p>
          </div>
          <nav className="nav">
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#events">Major Events</a></li>
              <li><a href="#members">Members</a></li>
              <li><a href="#jobs">Job Portal</a></li>
              <li><a href="#contact">Contact Us</a></li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-content">
          <div className="video-container">
            <img 
              src="https://images.pexels.com/photos/6937430/pexels-photo-6937430.jpeg" 
              alt="Professional chefs in action"
              className="hero-bg"
            />
            <div className="video-overlay">
              <div className="play-button">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                  <circle cx="40" cy="40" r="40" fill="rgba(255,255,255,0.9)"/>
                  <path d="M32 24L56 40L32 56V24Z" fill="#7B003E"/>
                </svg>
              </div>
              <h2>Salon Culinaire 2018</h2>
              <p>Experience the excellence of Qatar's finest culinary professionals</p>
            </div>
          </div>
        </div>
      </section>

      {/* Event Banner */}
      <section className="event-banner">
        <div className="container">
          <div className="banner-content">
            <div className="banner-text">
              <h3>The 4th Annual Global Hospitality and Horeca Show of Qatar</h3>
              <p className="tagline">Hospitality's Ultimate Meeting Point</p>
              <button className="cta-button">Learn More</button>
            </div>
            <div className="banner-image">
              <img 
                src="https://images.unsplash.com/photo-1745970747689-52782301cfb6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxob3NwaXRhbGl0eSUyMGV2ZW50fGVufDB8fHx8MTc1MTM5NzE3MHww&ixlib=rb-4.1.0&q=85" 
                alt="Hospitality Event Display"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Photo Gallery */}
      <section id="events" className="gallery">
        <div className="container">
          <h2>Event Highlights</h2>
          <p>Celebrating excellence in culinary arts</p>
          
          <div className="gallery-container">
            <button className="gallery-nav prev" onClick={prevImage}>‹</button>
            <div className="gallery-main">
              <img 
                src={galleryImages[currentImage].src} 
                alt={galleryImages[currentImage].alt}
                className="gallery-image"
              />
              <div className="gallery-caption">
                <p>{galleryImages[currentImage].alt}</p>
              </div>
            </div>
            <button className="gallery-nav next" onClick={nextImage}>›</button>
          </div>
          
          <div className="gallery-thumbnails">
            {galleryImages.map((image, index) => (
              <img
                key={index}
                src={image.src}
                alt={image.alt}
                className={`thumbnail ${index === currentImage ? 'active' : ''}`}
                onClick={() => setCurrentImage(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>About Qatar Culinary Professionals</h2>
              <p>
                Qatar Culinary Professionals (QCP) is a prestigious non-profit organization 
                representing the finest professional chefs in Qatar. We are proudly affiliated 
                with the World Association of Chefs Societies, connecting our members to a 
                global network of culinary excellence.
              </p>
              <p>
                Our mission is to promote culinary excellence through competitions, education, 
                and networking opportunities. We foster professional development, celebrate 
                culinary achievements, and support the growth of Qatar's vibrant food culture.
              </p>
              <div className="about-stats">
                <div className="stat">
                  <h3>500+</h3>
                  <p>Professional Members</p>
                </div>
                <div className="stat">
                  <h3>25+</h3>
                  <p>Major Events Annually</p>
                </div>
                <div className="stat">
                  <h3>15+</h3>
                  <p>Industry Partners</p>
                </div>
              </div>
            </div>
            <div className="about-image">
              <img 
                src="https://images.unsplash.com/photo-1730635250911-b787fbc7e90f" 
                alt="Professional chef in traditional uniform"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="partners">
        <div className="container">
          <h2>Our Valued Partners</h2>
          <div className="partners-grid">
            <div className="partner-logo">Nestlé</div>
            <div className="partner-logo">Sadia</div>
            <div className="partner-logo">Greenhouse</div>
            <div className="partner-logo">MPIOC</div>
            <div className="partner-logo">Qatar Airways</div>
            <div className="partner-logo">Marriott</div>
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="news">
        <div className="container">
          <h2>Latest News & Activities</h2>
          <div className="news-grid">
            <article className="news-item">
              <img 
                src="https://images.unsplash.com/photo-1613825787538-40df52ee2e08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxjdWxpbmFyeSUyMG1lZGFsc3xlbnwwfHx8fDE3NTEzOTcxNjZ8MA&ixlib=rb-4.1.0&q=85" 
                alt="Culinary competition awards"
              />
              <div className="news-content">
                <h3>Annual Culinary Competition Winners Announced</h3>
                <p>Celebrating outstanding achievements in culinary excellence...</p>
                <span className="news-date">December 2024</span>
              </div>
            </article>
            
            <article className="news-item">
              <img 
                src="https://images.unsplash.com/photo-1578366941741-9e517759c620?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjaGVmJTIwY29tcGV0aXRpb258ZW58MHx8fHwxNzUxMzk3MTc5fDA&ixlib=rb-4.1.0&q=85" 
                alt="Culinary team event"
              />
              <div className="news-content">
                <h3>Professional Development Workshop</h3>
                <p>Advanced culinary techniques and industry best practices...</p>
                <span className="news-date">November 2024</span>
              </div>
            </article>
            
            <article className="news-item">
              <img 
                src="https://images.unsplash.com/photo-1730635250973-aa696304add6" 
                alt="Chef precision cutting"
              />
              <div className="news-content">
                <h3>Masterclass Series: Precision Techniques</h3>
                <p>Learn from Qatar's most accomplished culinary masters...</p>
                <span className="news-date">October 2024</span>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h2>Contact Us</h2>
          <div className="contact-content">
            <div className="contact-form">
              <form>
                <div className="form-group">
                  <input type="text" placeholder="Full Name" required />
                </div>
                <div className="form-group">
                  <input type="tel" placeholder="Phone Number" required />
                </div>
                <div className="form-group">
                  <input type="email" placeholder="Email Address" required />
                </div>
                <div className="form-group">
                  <textarea placeholder="Your Message" rows="5" required></textarea>
                </div>
                <div className="form-group">
                  <div className="captcha-placeholder">
                    <span>Captcha verification would go here</span>
                  </div>
                </div>
                <button type="submit" className="submit-button">Send Message</button>
              </form>
            </div>
            <div className="contact-info">
              <div className="contact-item">
                <h4>Address</h4>
                <p>Qatar Culinary Professionals<br />
                Doha, Qatar</p>
              </div>
              <div className="contact-item">
                <h4>Phone</h4>
                <p>+974 XXXX XXXX</p>
              </div>
              <div className="contact-item">
                <h4>Email</h4>
                <p>info@qatarculinary.qa</p>
              </div>
              <div className="social-media">
                <h4>Follow Us</h4>
                <div className="social-icons">
                  <a href="#" className="social-icon">Instagram</a>
                  <a href="#" className="social-icon">Facebook</a>
                  <a href="#" className="social-icon">Twitter</a>
                  <a href="#" className="social-icon">YouTube</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h3>Qatar Culinary Professionals</h3>
              <p>Excellence in Culinary Arts</p>
            </div>
            <div className="footer-map">
              <p>📍 Located in Doha, Qatar</p>
              <p>Affiliated with World Association of Chefs Societies</p>
            </div>
            <div className="footer-contact">
              <p>📧 info@qatarculinary.qa</p>
              <p>📞 +974 XXXX XXXX</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Qatar Culinary Professionals. All rights reserved.</p>
            <p>Website designed with excellence in mind.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;